import { notification } from 'antd';
import React from 'react';

const SuccessIcon = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6" y="6" width="12" height="12" fill="white" />
    <path
      d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM16.7305 8.93555C16.4181 8.62334 15.912 8.62343 15.5996 8.93555L10.332 14.2031L8.39746 12.2686C8.08507 11.9563 7.57801 11.9563 7.26562 12.2686C6.95325 12.5809 6.95333 13.088 7.26562 13.4004L9.62402 15.7588C10.0145 16.1493 10.6485 16.1493 11.0391 15.7588L16.7305 10.0674C17.0429 9.75496 17.0429 9.24797 16.7305 8.93555Z"
      fill="#3ACE7D"
    />
  </svg>
);

const ErrorIcon = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 7C11.4477 7 11 7.44772 11 8V13C11 13.5523 11.4477 14 12 14C12.5523 14 13 13.5523 13 13V8C13 7.44772 12.5523 7 12 7ZM12 15.5C11.3096 15.5 10.75 16.0596 10.75 16.75C10.75 17.4404 11.3096 18 12 18C12.6904 18 13.25 17.4404 13.25 16.75C13.25 16.0596 12.6904 15.5 12 15.5Z"
      fill="#EF4444"
    />
  </svg>
);

export type ToastType = 'success' | 'error';

export interface ToastOptions {
  message: React.ReactNode;
  type?: ToastType;
  duration?: number;
}

const ICONS: Record<ToastType, React.ReactElement> = {
  success: <SuccessIcon />,
  error: <ErrorIcon />,
};

export const showToast = ({ message, type = 'success', duration = 3 }: ToastOptions): void => {
  notification.open({
    message: (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {ICONS[type]}
        <span style={{ fontSize: '16px', fontWeight: 500, lineHeight: '24px', color: '#111827', whiteSpace: 'nowrap' }}>
          {message}
        </span>
      </div>
    ),
    style: {
      padding: '12px 16px 4px',
      borderRadius: '8px',
      border: '1px solid #F2F3F5',
      boxShadow: '2px 6px 32px rgba(0,0,0,0.1)',
      width: 'fit-content',
      minWidth: 0,
    },
    placement: 'topRight',
    duration: duration,
    closable: false,
  });
};
